import React, { Component } from 'react'

class StatWidget extends Component {
  constructor (props) {
    super(props)
    this.state = {
      xs: 'col-xs-' + (this.props.xs || this.props.cols),
      sm: 'col-sm-' + (this.props.sm || this.props.cols),
      md: 'col-md-' + this.props.cols,
      lg: 'col-lg-' + (this.props.lg || this.props.cols),
      click: (this.props.onclick ? this.props.onclick : () => {})
    }
  }
  render () {
    return (
      <div className='statwidget-wrapper' onClick={e => { this.state.click(this) }}>
        <div className={[this.state.xs, this.state.sm, this.state.md, this.state.lg].join(' ')}>
          <div className='statwidget-inner'>
            <div className='statwidget-title'>
              <span>{this.props.title}</span>
            </div>
            <div className='statwidget-icon'>
              <i className={'fa ' + (this.props.icon ? this.props.icon : 'fa-ticket')} />
            </div>
            <div className='statwidget-value'>
              <span>{this.props.items}</span>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default StatWidget



// WEBPACK FOOTER //
// ./src/components/basic/displays/StatWidget.js